export default __webpack_public_path__ + "static/1-41fcc43c1c1b296b1e8d3f99c62ddcd5.jpg";